module.exports = __webpack_public_path__ + "static/media/16@720w.6ceb59bd.jpg";